"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedVersionAbstractForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
/**
 * Abstract Embed Version Form
 *
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
let EmbedVersionAbstractForm = class EmbedVersionAbstractForm extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        /**
         * Override this expression with appropriate version's expression
         * @protected
         */
        this.regex = /\$/;
    }
};
__decorate([
    vue_property_decorator_1.PropSync('content', { type: Object, required: false, default: () => ({}) }),
    __metadata("design:type", Object)
], EmbedVersionAbstractForm.prototype, "_content", void 0);
EmbedVersionAbstractForm = __decorate([
    vue_property_decorator_1.Component({
        name: 'EmbedVersionAbstractForm'
    })
], EmbedVersionAbstractForm);
exports.EmbedVersionAbstractForm = EmbedVersionAbstractForm;
//# sourceMappingURL=version.abstract.form.js.map